
import CreateWindow from "./fullscreenModal.js";
import logo from "./Aloitusruutu_Logo.png";
import { html, render } from "lit-html";
import bg from "./lopetusruutu_tausta.jpg";
import "./endingScreen.css";
import {tipsInterval} from "../helpers/checkGlow"
import {tipData, tips} from "../tips"
import { countUpTimer } from "../helpers/countUpTimer.js";
import { createShareButtons } from "../helpers/shareButtons.js";
import "./endscreen-icons/css/fontello.css"
import { iOSallowScroll } from "../helpers/iOSHacks.js";
import { textContents } from "../textcontents.js";
import { unsafeHTML } from "lit-html/directives/unsafe-html";

export const isSVTDuo = () => {
	const userAgent = window.navigator.userAgent.toLowerCase();
	return userAgent.indexOf("svtduo") > -1 || window.location.hash.includes("svtduo")
}
const svtLink = `<a href=\"https://www.svt.se/barnkanalen/barnplay/storyn-bakom\">svt.se/barnkanalen/barnplay/storyn-bakom</a>`

const shareButtons = html`
<div class="pako-share-btn" data-url=${"https://yle.fi/aihe/artikkeli/2020/11/10/trollibunkkeri"} data-title="${textContents.endingScreen.shareText}" data-desc="">
    <a class="btn-facebook" data-id="fb"><i class="icon-facebook"></i> Facebook</a>
    <a class="btn-twitter" data-id="tw"><i class="icon-twitter"></i> Twitter</a>
    <a class="btn-whatsapp" data-id="wa"><i class="icon-whatsapp"></i> WhatsApp</a>
</div>`


const FullscreenWindow = function () {
  const time = countUpTimer.checkTime()
  // CreateWindow palauttaa modaali-ikkunan noden, johon siis rendataan
  const fullscreenWindow = CreateWindow({});
  const markup = (loaded) => html`
<div class=${loaded ? "endingscreen-container loaded" : "endingscreen-container"} style=${`background-image: url(${bg})`}>
      <div class="endingscreen-content ${loaded ? "loaded": ""}">
        <div class="endingscreen-introduction">

        <h2>${textContents.endingScreen.title}</h2>
          <p>
      ${textContents.endingScreen.timeSpent} <b>${countUpTimer.checkTime()}</b> 
          </p>

          <p>
          ${unsafeHTML(`${textContents.endingScreen.linkText}<br/> ${isSVTDuo() ? svtLink : textContents.endingScreen.link}`)}
        </p>
        <p> ${textContents.endingScreen.recommend}
        
          </p>

          ${shareButtons}
        </div>
      </div>
    </div>
  `;

    let loadFinished = false;
    var img = new Image();
    img.onload = function() {
       loadFinished = true
       render(markup(true), fullscreenWindow.element);
    }
    img.src = bg;
    if (img.complete) img.onload();

    let tipsArrayed = Object.entries(tips)
    for (let index = 0; index < tipsArrayed.length; index++) {
      tipsArrayed[index][1].clear()
      
    }
    render(markup(loadFinished), fullscreenWindow.element);


    createShareButtons();
    clearInterval(tipsInterval)
    document.getElementById("renderCanvas").remove();
    document.querySelector(".puhelin-ikoni").remove();
    iOSallowScroll(".endingscreen-content")

};

export default FullscreenWindow;
